export class TariffType {
  id: string;
  code: string;

  constructor(tariffTypeInfo: any) {
    this.id = tariffTypeInfo.id;
    this.code = tariffTypeInfo.code;
  }
}
